<template>
  <div class="container">
    <div class="top_title"><router-link class="icon_back" :to="{name:'H010010'}" tag="span"></router-link><p>{{info.I_TITLE_NAME}}</p></div>

    <div class="books">
      <a v-for="item in info.dataList" class="book" @click="goToDetail(item)" >
        <div class="bookImg"  :style="{ 'background-image': 'url(' + item.I_ICON_QNY + ''}" >
            <!--<img :src="item.I_ICON_QNY" />-->
          </div>
          <p>{{item.I_NAME}}</p>
      </a>
    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'

  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: true,
          jchd: false,
          yyst: false,
          wd: false,
        },
        info: {
          I_BOOK_NO_SYS: "",
        },
        tabFlag: false,
        I_TYPE: 1,
      }
    },
    components: {
      Footer
    },
    created() {
      // this.info.I_TB_NO_SYS = this.$route.params.id
      // if(this.info.I_TB_NO_SYS) {
      //   window.localStorage.setItem("H110020", this.info.I_TB_NO_SYS)
      // } else {
      //   this.info.I_TB_NO_SYS = window.localStorage.getItem("H110020")
      // }
      this.I_TYPE = this.$route.params.type?this.$route.params.type:1
      let params = {
        I_TYPE: this.I_TYPE
      }
      DataRequestFactory.I4000601(params).then((response) => {
        this.info = response
      })
    },
    methods: {
      goToDetail(item) {
        // if(item.I_HTML_URL.indexOf("063") > 0) {
        //   window.localStorage.setItem("H400063",item.I_KEY)
        //   window.localStorage.setItem("H400060_source",'H400060')
        //   this.$router.push({name:item.I_HTML_URL})
        // } else {
          window.localStorage.setItem("H400061",item.I_KEY)
          this.$router.push({path:'/' + item.I_HTML_URL + '/' + item.I_KEY})
        // }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H400060.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H400060.vue